// Authenticated application shell for staff and developer users.
import { html, render } from '../utilities/html.js';
import { sidebar, highlightActiveNav } from '../components/sidebar.js';
import { topbar, renderBreadcrumbs, wireThemeButton, wireProfileMenu } from '../components/topbar.js';
import { notificationsMenu } from '../components/notifications-menu.js';
import { wireCommandSearch } from '../components/command-search.js';
import { getState } from '../state.js';
import { NAV_GROUPS, navItems } from '../modules/index.js';
import { updateMyProfile } from '../api/profile.api.js';
import { signOut } from '../auth/session.js';

export function mountStaffLayout(root, { navigate }) {
  const state = getState();
  render(root, html`
    <a class="skip-link" href="#main">Skip to content</a>
    <div class="app-shell" data-nav-open="false">
      <aside class="sidebar" id="sidebar" aria-label="Sidebar"></aside>
      <div class="sidebar-backdrop" data-action="close-nav"></div>
      <div class="main-col">
        <header class="topbar"></header>
        <main class="content" id="main" tabindex="-1"></main>
      </div>
    </div>`);

  const shell = root.querySelector('.app-shell');
  const side = root.querySelector('.sidebar');
  const top = root.querySelector('.topbar');
  const outlet = root.querySelector('#main');

  const paintSidebar = () => render(side, sidebar({ groups: NAV_GROUPS, items: navItems, permissions: getState().permissions, membership: getState().membership }));
  paintSidebar();
  render(top, topbar({ profile: state.profile, user: state.user }));

  const setNav = (open) => shell.setAttribute('data-nav-open', String(open));
  top.querySelector('[data-action="toggle-nav"]').addEventListener('click', () => setNav(shell.getAttribute('data-nav-open') !== 'true'));
  root.querySelector('[data-action="close-nav"]').addEventListener('click', () => setNav(false));
  side.addEventListener('click', (e) => { if (e.target.closest('a')) setNav(false); });

  wireThemeButton(top.querySelector('[data-action="theme"]'), (theme) => {
    updateMyProfile(getState().user.id, { theme }).catch(() => { /* local preference still applies */ });
  });
  wireProfileMenu(top);
  top.querySelector('[data-action="sign-out"]').addEventListener('click', () => signOut());
  const stopNotifications = notificationsMenu(top, state.user.id);
  const stopSearch = wireCommandSearch({ trigger: top.querySelector('[data-action="open-search"]'), items: navItems, getPermissions: () => getState().permissions, navigate });

  return {
    outlet,
    onRouteChange({ route, url }) {
      highlightActiveNav(side, navItems, url.pathname);
      renderBreadcrumbs(top.querySelector('[data-breadcrumbs]'), route?.breadcrumbs ?? []);
    },
    repaintSidebar: paintSidebar,
    destroy() { stopNotifications(); stopSearch(); },
  };
}
